/** @format */

// import React from "react";
import { StoreProvider } from "easy-peasy";
import { HelmetProvider } from "react-helmet-async";
import { useLocation, withRouter } from "react-router-dom";
import ErrorCatch from "./ErrorCatch";
import Routes from "./helpers/Routes";
import store from "./store";
import { CheckboxProvider } from "./pages/EventManager/CheckboxContext";
import { useIdleTimer } from 'react-idle-timer'
import moment from 'moment';

function App() {
  return (
    <>
      <div style={{ height: '100vh', background: 'linear-gradient(to bottom, #322A2A, #852331)' }}>
        <ErrorCatch>
          <StoreProvider store={store}>
            <CheckboxProvider>
              <HelmetProvider>
                <Routes />
              </HelmetProvider>
            </CheckboxProvider>
          </StoreProvider>
        </ErrorCatch>
      </div>
    </>
  );
}

export default withRouter(App);
